<script setup lang="ts">
import {
  NXGDSNavigationItem,
  NXGDSNavigationPanel,
  type NXGDSNavigationItemModel
} from '@nsftx/seven-nxg-design-system'
import type StaticContentTableOfContentsProps from './interfaces/StaticContentTableOfContentsProps'

defineProps<{
  headings: Array<StaticContentTableOfContentsProps>
}>()

const activeHeadingId = defineModel<string>()

const onItemClick = ({ uuid }: NXGDSNavigationItemModel) => {
  const el = document.getElementById(uuid)
  if (!el) return
  el.scrollIntoView({ behavior: 'instant', block: 'start' })
}
</script>

<template>
  <div v-if="headings.length" class="st-static-content-table-of-contents">
    <NXGDSNavigationPanel :model-value="headings" :title="$t('common_table_of_contents')">
      <template #item="{ item }">
        <NXGDSNavigationItem
          :title="item.title"
          :state="item.uuid === activeHeadingId ? 'active' : 'default'"
          size="md"
          @click="onItemClick(item)"
        />
      </template>
    </NXGDSNavigationPanel>
  </div>
</template>

<style scoped lang="scss">
.st-static-content-table-of-contents {
  display: flex;
  min-width: 400px;
  padding-top: var(--nxgds-alias-spacing-6xl);
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
}
</style>
